module.exports = __webpack_public_path__ + "img/1585774120.cbcc26d7.jpg";